module.exports = __webpack_public_path__ + "images/application/i-checkmark-big-68ff72f7.svg";